import { injectable, inject } from 'inversify';
import { ICommandShortcutService, ICommandShortcutHandler, ICommandShortcutHandlerProvider, ICommandShortcutContext } from '@/components/chat/_domain/modules/command-shortcut-service/command-shortcut-service-interface';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';

@injectable()
class CommandShortcutService implements ICommandShortcutService {
  private readonly commandShortcutHandlerProvider: ICommandShortcutHandlerProvider;
  private currentCommandShortcutHandler: ICommandShortcutHandler | null;
  private currentCommand: string;

  constructor(@inject(SERVICE_IDENTIFIERS.ICommandShortcutHandlerProvider) commandShortcutHandlerProvider: ICommandShortcutHandlerProvider) {
    this.commandShortcutHandlerProvider = commandShortcutHandlerProvider;
  }

  public processCommand(command: string, context: ICommandShortcutContext): boolean {
    this.currentCommand = command;
    this.chooseCommandShortcutHandlerForCurrentCommand(context);
    return this.processCurrentCommand(context);
  }

  private chooseCommandShortcutHandlerForCurrentCommand(context: ICommandShortcutContext): void {
    const commandShortcutHandlers = this.commandShortcutHandlerProvider
                                        .getAllHandlers()
                                        .filter((handler) => this.filterCommandShortcutHandlerForCurrentCommand(handler, context));

    this.currentCommandShortcutHandler = null;
    if (commandShortcutHandlers && commandShortcutHandlers.length > 0) {
      this.currentCommandShortcutHandler = commandShortcutHandlers[0];
    }
  }

  private filterCommandShortcutHandlerForCurrentCommand(commandShortcutHandler: ICommandShortcutHandler, context: ICommandShortcutContext): boolean {
    return commandShortcutHandler.canProcessCommand(this.currentCommand, context);
  }

  private processCurrentCommand(context: ICommandShortcutContext): boolean {
    if (this.currentCommandShortcutHandler !== null) {
      this.currentCommandShortcutHandler.processCommand(this.currentCommand, context);
      return true;
    }
    return false;
  }
}

export { CommandShortcutService };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/command-shortcut-service/command-shortcut-service.ts